// export default () => <h1>CoursesPage</h1>;

import React, { Component, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  Input,
  message,
  Avatar,
  Tooltip,
  Card,
  Spin,
  Layout,
  Result,
  PageHeader,
  Image,
  Typography,
  Switch,
  Checkbox,
  Table,
  Empty,
  Tabs,
} from "antd";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";

import {
  EditOutlined,
  FolderOpenOutlined,
  FontColorsOutlined,
  UserOutlined,
  AntDesignOutlined,
  PlusOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import Uppy from "@uppy/core";
import Tus from "@uppy/tus";
import GoogleDrive from "@uppy/google-drive";
import OneDrive from "@uppy/onedrive";
import uppyUrl from "@uppy/url";
import Dropbox from "@uppy/dropbox";
import { DashboardModal, Dashboard } from "@uppy/react";
// import { fetchFolders, changeFolderTitle } from "../../actions/workbookActions";
import CustomScrollbars from "../../utils/CustomScrollbars";
import Auxiliary from "../../utils/Auxiliary";
import axios from "axios";
// import NewLecture from "../misc/newLecture/NewLecture";
// import { FormattedMessage } from "react-intl";
// import messages from "../../messages";
// import Joyride from "react-joyride";
import size from "lodash/size";
import map from "lodash/map";
import arrayMove from "array-move";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import get from "lodash/get";

const { TabPane } = Tabs;
const { Header, Content, Footer } = Layout;

const DragHandle = sortableHandle(() => (
  <MenuOutlined style={{ cursor: "grab", color: "#999" }} />
));

const columns = [
  {
    title: "Sort",
    dataIndex: "sort",
    width: 30,
    className: "drag-visible",
    render: () => <DragHandle />,
  },
  {
    title: "Title",
    dataIndex: "title",
    className: "drag-visible",
  },
  {
    title: "Description",
    dataIndex: "content",
  },
  {
    title: "Resource",
    dataIndex: "resource_url",
  },
];

const SortableItem = sortableElement((props) => <tr {...props} />);
const SortableContainer = sortableContainer((props) => <tbody {...props} />);

const restrictions = {
  maxFileSize: 3 * 1024 * 1000, // 3 MB => 3 * 1024(kbs) * 1000(bs)
  maxNumberOfFiles: 1,
  minNumberOfFiles: 1,
  allowedFileTypes: ["image/*"],
};

const uppy = Uppy({
  id: "courseThumbnail",
  debug: process.env.NODE_ENV !== "production",
  autoProceed: false,
  restrictions,
})
  .use(Tus, { endpoint: "https://tus.contribute.cloud/files/" })
  .use(GoogleDrive, { companionUrl: "https://uppy.contribute.cloud" })
  .use(Dropbox, { companionUrl: "https://uppy.contribute.cloud" })
  .use(uppyUrl, { companionUrl: "https://uppy.contribute.cloud" })
  .use(OneDrive, { companionUrl: "https://uppy.contribute.cloud" });

const uppy2 = Uppy({
  id: "courseLesson",
  debug: process.env.NODE_ENV !== "production",
  autoProceed: false,
  restrictions,
})
  .use(Tus, { endpoint: "https://tus.contribute.cloud/files/" })
  .use(GoogleDrive, { companionUrl: "https://uppy.contribute.cloud" })
  .use(Dropbox, { companionUrl: "https://uppy.contribute.cloud" })
  .use(uppyUrl, { companionUrl: "https://uppy.contribute.cloud" })
  .use(OneDrive, { companionUrl: "https://uppy.contribute.cloud" });

const GreenStepItem = ({ data }) => {
  const { name, subject, description, created_at } = data;
  return (
    <>
      <Typography.Title
        level={5}
        type="secondary"
        ellipsis={{ rows: 2 }}
        className="gx-mb-0"
      >
        {description}
      </Typography.Title>

      <Typography.Paragraph
        type="secondary"
        ellipsis={{ rows: 4 }}
        className="gx-mb-0"
      >
        {description}
      </Typography.Paragraph>
    </>
  );
};

const GreenStepCard = ({ slide, onOpen, onRename, folder }) => {
  const [image, setImage] = useState(
    slide[0]?.slide[0]?.thumbnail || `/images/build-lecture.png`
  );
  const [loading, setLoading] = useState(false);

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 800,
    marginLeft: 10,
    marginRight: 10,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    autoplay: true,
  };
  return (
    <Card
      bodyStyle={{ height: "100%" }}
      className="gx-card-widget gx-card-full"
    >
      {slide.published && (
        <span
          className="gx-widget-badge"
          style={{ ...(slide.published ? { background: "green" } : {}) }}
        >
          Published Course
        </span>
      )}
      <Row className="gx-h-100">
        <Col xl={12} lg={12} md={12} sm={12} xs={24}>
          <div className="gx-slick-slider-lt-thumb">
            <img
              className={
                loading
                  ? "fadeout gx-img-fluid gx-mh300"
                  : "fadein gx-img-fluid gx-mh300"
              }
              src={image}
              alt={slide.name}
              onError={(e) => (
                (e.target.onerror = null),
                (e.target.src = `images/build-lecture.png`)
              )}
              // fallback="data:image/png;base64,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"
            />
          </div>
        </Col>
        <Col xl={12} lg={12} md={12} sm={12} xs={24}>
          <Slider
            className="gx-slick-slider gx-slick-slider-dot-top"
            {...settings}
            // afterChange={(index) => {
            //   setLoading(false);
            //   setImage(slide[index]?.slide[index]?.thumbnail);
            // }}
            // beforeChange={(oldIndex, newIndex) => {
            //   setLoading(true);
            // }}
          >
            <GreenStepItem key={1} data={slide} />
            {/* {slide.length ? (
              slide.map((data, index) => (
                <GreenStepItem key={index} data={data} />
              ))
            ) : (
              <GreenStepItem key={1} data={{}} />
            )} */}
          </Slider>
          {/* <Button.Group> */}
          <div>
            <Tooltip title="Add new lesson">
              <Button
                icon={<PlusOutlined className="gx-fs-xl" />}
                shape="circle"
                onClick={() => onOpen()}
                type="primary"
              />
            </Tooltip>
            <Button
              icon={<EditOutlined className="gx-fs-xl" />}
              shape="circle"
              onClick={() => onRename()}
              type="primary"
            />
          </div>

          {/* <Button onClick={() => {}} type="primary">
              Rename
            </Button> */}
          {/* </Button.Group> */}
        </Col>
      </Row>
    </Card>
  );
};

const CoursesPage = ({}) => {
  const currentUser = useSelector((state) => get(state, ["auth", "user"]));

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isRenameModalVisible, setIsRenameModalVisible] = useState(false);
  const [isManageModalVisible, setIsManageModalVisible] = useState(false);
  const [isLessonModalVisible, setIsLessonModalVisible] = useState(false);
  const [courseItem, setCourseItem] = useState({});
  const [courseLessons, setCourseLessons] = useState([]);
  const [currentName, setCurrentName] = useState("");
  const [courseId, setCourseId] = useState("");

  const [searchText, setSearchText] = useState("");
  const [lmsCourses, setLmsCourses] = useState([]);
  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const fetchLmsCourses = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/lmsCourse/courses`,
      {}
    );

    setLmsCourses(result.data.courses);
  };

  const onFinish = async ({ course }) => {
    try {
      let thumbnailUrl = "";
      let thumbnailExtension = "";
      const files = uppy.getFiles();
      if (size(files)) {
        const uppyUpload = uppy.upload();
        const uppyResult = await uppyUpload;
        thumbnailUrl = uppyResult.successful[0].uploadURL;
        thumbnailExtension = uppyResult.successful[0].extension;
      }

      const result = await axios.post(
        `${process.env.REACT_APP_API_HOST}/api/lmsCourse/courses`,
        { ...course, thumbnailUrl, thumbnailExtension }
      );
      fetchLmsCourses();
      message.success(result.data.message);
      handleCancel();
    } catch (e) {
      message.error(e?.message);
    }
  };

  const onFinishChangeCourseName = async (values) => {
    const result = await axios.put(
      `${process.env.REACT_APP_API_HOST}/api/lmsCourse/courses`,
      { ...values, id: courseId }
    );
    setIsRenameModalVisible(false);
    fetchLmsCourses();
    message.success(result.data.message);
  };

  const onFinishAddLesson = async (values) => {
    try {
      let fileUrl = "";
      let fileExtension = "";
      const files = uppy2.getFiles();

      if (size(files)) {
        const uppyUpload = uppy2.upload();
        const uppyResult = await uppyUpload;
        fileUrl = uppyResult.successful[0].uploadURL;
        fileExtension = uppyResult.successful[0].extension;

        const result = await axios.put(
          `${process.env.REACT_APP_API_HOST}/api/lmsCourse/courses`,
          { lesson: { ...values, fileUrl, fileExtension }, id: courseItem._id }
        );
        // debugger;
        // setIsRenameModalVisible(false);
        // fetchLmsCourses();
        message.success(result.data.message);
        setIsLessonModalVisible(false);
        uppy2.reset();
      } else {
        message.error("Please upload lesson content");
      }
    } catch (error) {
      message.error(error?.message);
    }
  };

  const useEffectOnMount = (effect) => {
    useEffect(effect, []);
  };
  useEffectOnMount(() => {
    fetchLmsCourses();
    return () => {
      uppy.close();
      uppy2.close();
    };
  });

  const onSortEnd = ({ oldIndex, newIndex }) => {
    // debugger;
    if (oldIndex !== newIndex) {
      const newData = arrayMove(
        [].concat(courseItem.lessons),
        oldIndex,
        newIndex
      ).filter((el) => !!el);
      console.log("Sorted items: ", newData);
      setCourseLessons(newData);
    }
  };
  const DraggableContainer = (props) => (
    <SortableContainer
      useDragHandle
      disableAutoscroll
      helperClass="row-dragging"
      onSortEnd={onSortEnd}
      {...props}
    />
  );

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    // function findIndex base on Table rowKey props and should always be a right array index
    const index = courseItem.lessons.findIndex(
      (x) => x._id === restProps["data-row-key"]
    );
    return (
      <SortableItem style={{ zIndex: 9999 }} index={index} {...restProps} />
    );
  };

  return (
    <>
      {get(currentUser, "educator") ? (
        <>
          {!size(lmsCourses) ? (
            <Layout.Content
              style={{
                minHeight: "calc(100% - 192px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Result
                className="gx-p-0 gx-empty-holder-frame gx-pointer"
                icon={
                  <>
                    <figure onClick={showModal}>
                      <img src={"images/old_icons/new_lecture.png"} />
                    </figure>

                    <span>
                      Contribute Cloud everyday helps us collaborate, cast and
                      play
                    </span>
                  </>
                }
              />
            </Layout.Content>
          ) : (
            <CustomScrollbars className="gx-content-scroll gx-text-center">
              <PageHeader
                className="gx-mb-4"
                ghost={false}
                title={`Courses List`}
                extra={[
                  <Button onClick={showModal} type="primary">
                    Create New Course
                  </Button>,
                  <Input.Search
                    style={{ width: 300 }}
                    placeholder="Search course"
                    allowClear
                    onChange={(ev) => setSearchText(ev.target.value)}
                    onSearch={(value) => setSearchText(value)}
                  />,
                ]}
              />
              <div className="gx-card-list">
                {map(lmsCourses, (item, key) => (
                  <GreenStepCard
                    onOpen={() => {
                      setCourseItem(item);
                      setCourseId(item._id);
                      setCourseLessons(item.lessons);
                      setIsManageModalVisible(true);
                    }}
                    onRename={() => {
                      setCourseId(item._id);
                      setCurrentName(item.name);
                      setIsRenameModalVisible(true);
                    }}
                    slide={item}
                  />
                ))}
              </div>

              <Modal
                title="Change Course Name"
                visible={isRenameModalVisible}
                okText={"Save"}
                okButtonProps={{
                  form: "changeCourseName",
                  key: "submit",
                  htmlType: "submit",
                  size: "large",
                }}
                onCancel={() => {
                  setCurrentName("");
                  setIsRenameModalVisible(false);
                }}
                cancelButtonProps={{
                  size: "large",
                }}
              >
                <Form
                  name="changeCourseName"
                  size="large"
                  initialValues={{ name: currentName }}
                  onFinish={onFinishChangeCourseName}
                >
                  <Form.Item
                    name="name"
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                  >
                    <Input placeholder="Course Name" />
                  </Form.Item>
                </Form>
              </Modal>

              <Modal
                title="Add New Lesson"
                visible={isLessonModalVisible}
                width={700}
                okText={"Save"}
                destroyOnClose={true}
                okButtonProps={{
                  form: "addNewLesson",
                  key: "submit",
                  htmlType: "submit",
                  size: "large",
                }}
                onCancel={() => {
                  setIsLessonModalVisible(false);
                }}
                cancelButtonProps={{
                  size: "large",
                }}
              >
                <Form
                  name="addNewLesson"
                  size="large"
                  initialValues={{}}
                  onFinish={onFinishAddLesson}
                >
                  <Form.Item
                    name="title"
                    labelCol={{ span: 24 }}
                    label="Lesson Title"
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name={"content"}
                    labelCol={{ span: 24 }}
                    label="Lesson Content"
                    rules={[{ required: true }]}
                  >
                    <Input.TextArea />
                  </Form.Item>

                  <Form.Item labelCol={{ span: 24 }} label="Lesson Resource">
                    <Dashboard
                      height={250}
                      hideUploadButton={true}
                      // disableThumbnailGenerator={true}
                      proudlyDisplayPoweredByUppy={false}
                      hideProgressAfterFinish={true}
                      uppy={uppy2}
                      plugins={["GoogleDrive", "Dropbox", "OneDrive"]}
                    />
                  </Form.Item>
                </Form>
              </Modal>

              <Modal
                title="Manage Course"
                visible={isManageModalVisible}
                width={700}
                okText={"Save"}
                okButtonProps={{
                  form: "changeCourseName",
                  key: "submit",
                  htmlType: "submit",
                  size: "large",
                }}
                onCancel={() => {
                  setCourseItem({});
                  setIsManageModalVisible(false);
                }}
                cancelButtonProps={{
                  size: "large",
                }}
              >
                <Form
                  name="changeCourseName"
                  size="large"
                  initialValues={{
                    name: courseItem.name,
                    description: courseItem.description,
                    published: courseItem.published,
                  }}
                  onFinish={onFinishChangeCourseName}
                >
                  <Form.Item
                    name="name"
                    labelCol={{ span: 24 }}
                    label="Name"
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                  >
                    <Input placeholder="Course Name" />
                  </Form.Item>

                  <Form.Item
                    name={"description"}
                    labelCol={{ span: 24 }}
                    label="Introduction"
                    rules={[{ required: true }]}
                  >
                    <Input.TextArea />
                  </Form.Item>

                  <Form.Item name={"published"} valuePropName="checked">
                    <Checkbox>Publish Course</Checkbox>
                  </Form.Item>

                  <Table
                    pagination={false}
                    dataSource={courseLessons}
                    columns={columns}
                    rowKey="_id"
                    components={{
                      body: {
                        wrapper: DraggableContainer,
                        row: DraggableBodyRow,
                      },
                    }}
                  />

                  <Button
                    size="large"
                    type="primary"
                    block
                    onClick={() => setIsLessonModalVisible(true)}
                  >
                    New Lesson
                  </Button>
                </Form>
              </Modal>
            </CustomScrollbars>
          )}
        </>
      ) : (
        <Content>
          <Tabs tabPosition={"left"} onChange={() => true} type="card">
            <TabPane tab="All Courses" key="1">
              Content of Tab Pane 1
            </TabPane>
            <TabPane tab="Enrolled Courses" key="2">
              Content of Tab Pane 2
            </TabPane>
          </Tabs>
        </Content>
      )}

      <Modal
        title="Create Course"
        visible={isModalVisible}
        okText="Save"
        onCancel={handleCancel}
        width={700}
        okButtonProps={{
          form: "createCourse",
          htmlType: "submit",
        }}
      >
        <Form
          form={form}
          id="createCourse"
          name="course-messages"
          onFinish={onFinish}
        >
          <Form.Item
            labelCol={{ span: 24 }}
            name={["course", "name"]}
            label="Name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={["course", "description"]}
            labelCol={{ span: 24 }}
            label="Introduction"
            rules={[{ required: true }]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item labelCol={{ span: 24 }} label="Thumbnail">
            <Dashboard
              height={250}
              hideUploadButton={true}
              // disableThumbnailGenerator={true}
              proudlyDisplayPoweredByUppy={false}
              hideProgressAfterFinish={true}
              uppy={uppy}
              plugins={["GoogleDrive", "Dropbox", "OneDrive"]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CoursesPage;
